import React from "react";
import { formatNumber } from "helpers/common";
import StatCard from "../Components/StatCard.jsx";
import StatGrid from "../Components/statGrid.jsx";
import SectionLabel from "../Components/SectionLabel.jsx";

const UsersTab = ({ data = {} }) => {
  const total = data?.totalUserCount || 0;
  const active = data?.totalActiveUserCount || 0;
  const deleted = data?.totalDeleteUserCount || 0;
  const sleepy = data?.totalSleepyUserCount || 0;

  const activeRate = total > 0 ? ((active / total) * 100).toFixed(1) : "0.0";
  const churnRate = total > 0 ? ((deleted / total) * 100).toFixed(1) : "0.0";
  const dormancy = total > 0 ? ((sleepy / total) * 100).toFixed(1) : "0.0";

  return (
    <>
      <SectionLabel>User overview</SectionLabel>
      <StatGrid>
        <StatCard
          label="Total users"
          value={data?.totalUserCount}
          sub="All registered accounts"
          accent="blue"
        />
        <StatCard
          label="Active users"
          value={data?.totalActiveUserCount}
          sub="Currently active"
          accent="green"
        />
        <StatCard
          label="New users"
          value={data?.totalNewUserCount}
          sub="Recent signups"
          accent="teal"
        />
        <StatCard
          label="Sleepy users"
          value={data?.totalSleepyUserCount}
          sub="Inactive / dormant"
          accent="amber"
        />
        <StatCard
          label="Deleted users"
          value={data?.totalDeleteUserCount}
          sub="Removed accounts"
          accent="red"
        />
      </StatGrid>

      <SectionLabel>User Linked overview</SectionLabel>
      <StatGrid>
        <StatCard
          label="Total Linked Users"
          value={data?.totalLinkedCount}
          sub="Linked User accounts"
          accent="blue"
        />
        <StatCard
          label="Total UnLinked Users"
          value={data?.totalUnLinkedCount}
          sub="UnLinked User accounts"
          accent="green"
        />
        <StatCard
          label="Today Linked Users"
          value={data?.totalTodayLinkedCount}
          sub="Today Linked User accounts"
          accent="teal"
        />
      </StatGrid>

      <p style={{ fontSize: 12, color: "#adb5bd", marginTop: 4 }}>
        Active rate: <strong style={{ color: "#6c757d" }}>{activeRate}%</strong>
        &nbsp;·&nbsp; Churn rate:{" "}
        <strong style={{ color: "#6c757d" }}>{churnRate}%</strong>
        &nbsp;·&nbsp; Dormancy rate:{" "}
        <strong style={{ color: "#6c757d" }}>{dormancy}%</strong>
      </p>
    </>
  );
};

export default UsersTab;
